import { Typography, TypographyProps } from "@mui/material";
import React from "react";
import { useGetDispatchersQuery } from "../../../api/employeesApi";
import { useGetTrailerByIdQuery } from "../../../api/trailersApi";
import { useGetVehicleByIdQuery } from "../../../api/vehiclesApi";
import {
  formatDispatcherDisplayLabel,
  formatTrailerDisplayLabel,
  formatVehicleDisplayLabel,
} from "../auditEntityRegistry";

interface AssignmentEntityLabelProps extends TypographyProps {
  entityType: "Vehicle" | "Trailer" | "Employee";
  entityId?: number;
  fallback?: string;
  open?: boolean;
}

const AssignmentEntityLabel: React.FC<AssignmentEntityLabelProps> = ({
  entityType,
  entityId,
  fallback,
  open = true,
  ...typographyProps
}) => {
  const skip = !open || !entityId;
  const vehicleQuery = useGetVehicleByIdQuery(entityId ?? 0, {
    skip: skip || entityType !== "Vehicle",
  });
  const trailerQuery = useGetTrailerByIdQuery(entityId ?? 0, {
    skip: skip || entityType !== "Trailer",
  });
  const dispatchersQuery = useGetDispatchersQuery(undefined, {
    skip: skip || entityType !== "Employee",
  });

  let label = fallback;

  if (entityType === "Vehicle") {
    label = formatVehicleDisplayLabel(vehicleQuery.data) ?? fallback ?? `Vehicle #${entityId}`;
  } else if (entityType === "Trailer") {
    label = formatTrailerDisplayLabel(trailerQuery.data) ?? fallback ?? `Trailer #${entityId}`;
  } else if (entityType === "Employee" && entityId) {
    const dispatcher = dispatchersQuery.data?.find((item) => item.id === entityId);
    label =
      formatDispatcherDisplayLabel(dispatcher) ?? fallback ?? `Dispatcher #${entityId}`;
  }

  return (
    <Typography component="span" noWrap color="inherit" {...typographyProps}>
      {label ?? "-"}
    </Typography>
  );
};

export default AssignmentEntityLabel;
